import Link from 'gatsby-link';
import React from 'react';

import ParticipantListing from '../components/participant-listing.js';

export default ({ data }) =>
  <div>
    <div className="breadcrumb">
      <Link to="/">
        Home
      </Link>
      <span> › </span>
      TeilnehmerInnen
    </div>

    <div className="title">
      TeilnehmerInnen
    </div>

    <ParticipantListing participants={data.allParticipantsYaml.edges.map(edge => edge.node)} />
  </div>
;

export const query = graphql`
  query Participants {
    allParticipantsYaml(filter: { schema: { ne: true } }) {
      edges {
        node {
          ...ParticipantListingFields
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/participants.js